import { Immutable } from "immer";
import React from "react";
import { getGlobalSpacingClasses } from "tsi-common-react/src/components/_spacing/globalSpacing";
import { getReactivatedContext } from "tsi-common-react/src/utils/environment";
import { t } from "ttag";

import {
    Context,
    type MattressSelectBlock as MattressSelectBlockValue,
} from "@reactivated";

import { concatClassNames } from "@thelabnyc/thelabui/src/utils/styles";

import { StarRating } from "../StarRating";

import styles from "./index.module.scss";

const useStaticURL = (): string => {
    const context = React.useContext(Context) || getReactivatedContext();
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
    return context?.STATIC_URL ?? "/static/";
};

const getStaticURL = (staticURL: string, path: string): string =>
    `${staticURL}${path}`;

type IProps = Immutable<{ value: MattressSelectBlockValue }>;

export const MattressSelectBlock = (props: IProps): React.JSX.Element => {
    const staticURL = useStaticURL();
    const leftMattress = getStaticURL(
        staticURL,
        "img/homepage/cocoon-corner-left-mattress.png",
    );
    const rightMattress = getStaticURL(
        staticURL,
        "img/homepage/cocoon-corner-right-mattress.png",
    );

    return (
        <section
            className={concatClassNames([
                styles.homeOct16MattressSelect,
                "home-oct16-mattress-select",
                getGlobalSpacingClasses(props.value.spacing),
            ])}
        >
            <img
                src={leftMattress}
                className={`${styles.bgImage} ${styles.bgImageLeft}`}
                alt=""
                loading="lazy"
                decoding="async"
            />
            <img
                src={rightMattress}
                className={`${styles.bgImage} ${styles.bgImageRight}`}
                alt=""
                loading="lazy"
                decoding="async"
            />
            <div className="main-container">
                <div className={styles.homeOct16MattressSelectTitle}>
                    {props.value.title}
                </div>
                <div className={styles.homeOct16MattressSelectSubTitle}>
                    {props.value.subtitle}
                </div>
                <div className={styles.links}>
                    {(props.value.products ?? []).map((link, index) => (
                        <div className={styles.selectLink} key={index}>
                            <a
                                className={concatClassNames([
                                    styles.homeOct16MattressSelectLinkButton,
                                    "button",
                                ])}
                                href={link.link?.page?.url}
                            >
                                Shop {link.link?.link_title}
                            </a>
                            <div className={styles.selectLinkStars}>
                                <StarRating
                                    rating={link.stars}
                                    inverted
                                    className={styles.selectLinkStarsContainer}
                                    ratingClassName={
                                        styles.selectLinkStarsRating
                                    }
                                    srLabel
                                />
                            </div>
                            <div className={styles.selectLinkPricing}>
                                {t`Starting at`} ${link.price}
                            </div>
                        </div>
                    ))}
                </div>
                <div className={styles.financing}>
                    <p>{props.value.financing_copy}</p>
                    {props.value.financing_link ? (
                        <p>
                            <a href={props.value.financing_link.page?.url}>
                                Learn More
                            </a>
                        </p>
                    ) : null}
                </div>
            </div>
        </section>
    );
};
